/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * VRScore
 * VR Score as calculated from FR1 is a float number between 1-5.
 * We map these to the 5 values of the enum by rounding up if the first
 * decimal is >= 5 and down if < 5. (e.g. 3.4 maps to 3 which is MEDIUM
 * while 3.5 maps to 4 which is HIGH)
 */
export enum VRScore {
  LOWEST = "LOWEST",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  HIGHEST = "HIGHEST",
  NA = "NA",
}

/** SubscriptionTier */
export enum SubscriptionTier {
  STANDARD = "STANDARD",
  PRO = "PRO",
}

/** SortType */
export enum SortType {
  NTM = "NTM",
  LTM = "LTM",
}

/** SortOrder */
export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

/** SortDirection */
export enum SortDirection {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

/** SortBy */
export enum SortBy {
  ID = "ID",
  EXTERNAL_ID = "EXTERNAL_ID",
  NAME = "NAME",
  PROPERTY_TYPE = "PROPERTY_TYPE",
  COUNTRY = "COUNTRY",
  STATE = "STATE",
  CITY = "CITY",
  EXPOSURE = "EXPOSURE",
  HIGH_RISK_EXPOSURE = "HIGH_RISK_EXPOSURE",
  DRAWN_AMOUNT = "DRAWN_AMOUNT",
  UNDRAWN_AMOUNT = "UNDRAWN_AMOUNT",
  RISK_SCORE = "RISK_SCORE",
  DSCR = "DSCR",
  LTV = "LTV",
  ICR = "ICR",
  INTEREST_RATE = "INTEREST_RATE",
  MATURITY_DATE = "MATURITY_DATE",
  REMAINING_TENURE = "REMAINING_TENURE",
  VALUATION = "VALUATION",
  RENT = "RENT",
  REPORTED_DATE = "REPORTED_DATE",
}

/** ScorecardTier */
export enum ScorecardTier {
  STARTER = "STARTER",
  STANDARD = "STANDARD",
  PRO = "PRO",
}

/** RiskScore */
export enum RiskScore {
  LOWEST = "LOWEST",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  HIGHEST = "HIGHEST",
  NA = "NA",
}

/** RangeType */
export enum RangeType {
  LTM = "LTM",
  NTM = "NTM",
}

/** PropertyType */
export enum PropertyType {
  COMMERCIAL = "COMMERCIAL",
  HOTEL_LIMITED_SERVICE = "HOTEL_LIMITED_SERVICE",
  HOTEL_FULL_SERVICE = "HOTEL_FULL_SERVICE",
  HOTEL_ALL = "HOTEL_ALL",
  INDUSTRIAL = "INDUSTRIAL",
  MIXED_USE = "MIXED_USE",
  MULTIFAMILY = "MULTIFAMILY",
  OFFICE = "OFFICE",
  OTHER = "OTHER",
  RESIDENTIAL = "RESIDENTIAL",
  RETAIL = "RETAIL",
  SENIOR_HOUSING = "SENIOR_HOUSING",
  STUDENT_HOUSING = "STUDENT_HOUSING",
  WAREHOUSE = "WAREHOUSE",
}

/** PeriodType */
export enum PeriodType {
  QUARTERLY = "QUARTERLY",
  ANNUAL = "ANNUAL",
}

/** Operation */
export enum Operation {
  CHANGE = "CHANGE",
  PERCENT_CHANGE = "PERCENT_CHANGE",
}

/** ONCIScenario */
export enum ONCIScenario {
  DOMAIN_MODEL = "DOMAIN_MODEL",
  BASE_SCENARIO = "BASE_SCENARIO",
  STRESS_CASE_1_SCENARIO = "STRESS_CASE_1_SCENARIO",
}

/** MetricDataType */
export enum MetricDataType {
  NUMERIC = "NUMERIC",
  MONETARY = "MONETARY",
  RATIO = "RATIO",
  PERCENTAGE = "PERCENTAGE",
  SCORE = "SCORE",
  SQUARE_FEET = "SQUARE_FEET",
}

/** LoanbookType */
export enum LoanbookType {
  CRE = "CRE",
  CI = "CI",
}

/** FinancialsType */
export enum FinancialsType {
  ACTUAL = "ACTUAL",
  NOWCASTED = "NOWCASTED",
  FORECASTED = "FORECASTED",
}

/** FileType */
export enum FileType {
  ON_UPLOADS = "ON_UPLOADS",
  SUPPORTING_FILE_UPLOADS = "SUPPORTING_FILE_UPLOADS",
}

/** ExplainabilityStatus */
export enum ExplainabilityStatus {
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  ERROR = "ERROR",
}

/** EntityType */
export enum EntityType {
  BORROWER = "BORROWER",
  LOAN = "LOAN",
  ASSET = "ASSET",
  UNIT = "UNIT",
}

/** EntityMetricSignificance */
export enum EntityMetricSignificance {
  NORMAL = "NORMAL",
  BOLD = "BOLD",
  BOLD_AND_UNDERLINE = "BOLD_AND_UNDERLINE",
}

/** DocumentCategory */
export enum DocumentCategory {
  GENERAL = "GENERAL",
  BORROWER = "BORROWER",
}

/** DateReference */
export enum DateReference {
  CURRENT_DATE = "CURRENT_DATE",
  LATEST_ACTUAL = "LATEST_ACTUAL",
  MATURITY_DATE = "MATURITY_DATE",
}

/** Comparator */
export enum Comparator {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  GREATER_OR_EQUAL = "GREATER_OR_EQUAL",
  LESS_THAN = "LESS_THAN",
  LESS_OR_EQUAL = "LESS_OR_EQUAL",
}

/** ClimateScore */
export enum ClimateScore {
  LOWEST = "LOWEST",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  HIGHEST = "HIGHEST",
  LOCKED = "LOCKED",
}

/** ClimateScenario */
export enum ClimateScenario {
  NET_ZERO_2050 = "NET_ZERO_2050",
  BELOW_2_C = "BELOW_2_C",
  FRAGMENTED_WORLD = "FRAGMENTED_WORLD",
  DELAYED_TRANSITION = "DELAYED_TRANSITION",
  CURRENT_POLICIES = "CURRENT_POLICIES",
  NATIONALLY_DETERMINED_CONTRIBUTIONS = "NATIONALLY_DETERMINED_CONTRIBUTIONS",
}

/** CalculationStatus */
export enum CalculationStatus {
  CALCULATING = "CALCULATING",
  COMPLETED = "COMPLETED",
}

/** CREPropertyType */
export enum CREPropertyType {
  MULTIFAMILY = "MULTIFAMILY",
  RESIDENTIAL_HOME = "RESIDENTIAL_HOME",
  INDUSTRIAL = "INDUSTRIAL",
  OFFICE = "OFFICE",
  RETAIL = "RETAIL",
  WAREHOUSE = "WAREHOUSE",
  HOTELS = "HOTELS",
  RESIDENTIAL_APARTMENT = "RESIDENTIAL_APARTMENT",
  OTHER = "OTHER",
}

/** CRELoanType */
export enum CRELoanType {
  INVESTMENT = "INVESTMENT",
  CONSTRUCTION = "CONSTRUCTION",
}

/** BorrowerSortField */
export enum BorrowerSortField {
  BorrowerName = "borrower_name",
  BorrowerInternalRiskRating = "borrower_internal_risk_rating",
  BorrowerExposure = "borrower_exposure",
}

/** AlertRule */
export interface AlertRule {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  scenario: Scenario;
  loanbook_type: LoanbookType;
  entity_type: EntityType;
  /** Entity Filters */
  entity_filters: CIBorrowerFilters | CREEntityFilters;
  /** Conditions */
  conditions: BinaryCondition[];
  /** Additional Metrics */
  additional_metrics: Metric[];
}

/** AlertRuleListItem */
export interface AlertRuleListItem {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  scenario: Scenario;
}

/** AssetImage */
export interface AssetImage {
  /** Id */
  id: number;
  /** Download Url */
  download_url: string;
  /** File Name */
  file_name: string;
  /**
   * Uploaded At
   * @format date
   */
  uploaded_at: string;
  /** Uploaded By */
  uploaded_by: string | null;
}

/** AssetImageUpload */
export interface AssetImageUpload {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** File Name */
  file_name: string;
  /** File Key */
  file_key: string;
}

/** AssetImagesResponse */
export interface AssetImagesResponse {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** Total Image Count */
  total_image_count: number;
  /** Images */
  images: AssetImage[];
}

/** AssetMetricsNTMResponse */
export interface AssetMetricsNTMResponse {
  /** Metrics */
  metrics: EntityMetricNTM[];
}

/** AssetNotesResponse */
export interface AssetNotesResponse {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** Asset Notes */
  asset_notes: EntityNote[];
}

/** AssetTenantsResponse */
export interface AssetTenantsResponse {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** Asset Tenants */
  asset_tenants: Tenant[];
}

/**
 * AssetUploadUrl
 * Wraps a presigned S3 URL to upload a file to
 */
export interface AssetUploadUrl {
  /** Url */
  url: string;
  /** File Key */
  file_key: string;
  /** Form Fields */
  form_fields: Record<string, string>;
}

/** AvailableMetricsResponse */
export interface AvailableMetricsResponse {
  /** Metrics */
  metrics: Metric[];
}

/** BinaryCondition */
export interface BinaryCondition {
  /** Left */
  left:
    | ({
        type: "CALCULATED_VALUE";
      } & CalculatedValue)
    | ({
        type: "LITERAL";
      } & LiteralValue)
    | ({
        type: "METRIC_VALUE";
      } & ScenarioMetricValue);
  /** Right */
  right:
    | ({
        type: "CALCULATED_VALUE";
      } & CalculatedValue)
    | ({
        type: "LITERAL";
      } & LiteralValue)
    | ({
        type: "METRIC_VALUE";
      } & ScenarioMetricValue);
  comparator: Comparator;
  /** Text */
  text?: string | null;
}

/** BorrowerSpread */
export interface BorrowerSpread {
  /** Id */
  id: string;
  /** Source Row Index */
  source_row_index: number;
  /** Valid */
  valid: boolean;
  /** Exclusion Reasons */
  exclusion_reasons: string | null;
  /** Warning Reasons */
  warning_reasons: string | null;
}

/** BorrowerSpreadAuditResponse */
export interface BorrowerSpreadAuditResponse {
  /** Source File Upload Date */
  source_file_upload_date: string | null;
  /** Files */
  files: BorrowerSpreadFile[];
}

/** BorrowerSpreadFile */
export interface BorrowerSpreadFile {
  /** Original Filename */
  original_filename: string;
  /** Input File Id */
  input_file_id: number;
  /** Spreads */
  spreads: BorrowerSpread[];
}

/** CIAlertRuleInput */
export interface CIAlertRuleInput {
  /** Name */
  name: string;
  /**
   * Scenario Id
   * @format uuid
   */
  scenario_id: string;
  /** Conditions */
  conditions: Record<string, any>[];
  /** Additional Metrics */
  additional_metrics: string[];
  /** Loanbook Type */
  loanbook_type: "CI";
  /** Entity Type */
  entity_type: "BORROWER";
  filters: CIBorrowerFilters;
}

/** CIBorrowerFilters */
export interface CIBorrowerFilters {
  exposure?: RangeFilter | null;
  /** Sector Code */
  sector_code?: string[] | null;
  /** Industry Group Code */
  industry_group_code?: string[] | null;
  /** Industry Code */
  industry_code?: string[] | null;
  /** Cost Center */
  cost_center?: string[] | null;
  /** Business Unit */
  business_unit?: string[] | null;
  /** Relationship Manager */
  relationship_manager?: string[] | null;
  /** Portfolio Manager */
  portfolio_manager?: string[] | null;
  /** Credit Officer */
  credit_officer?: string[] | null;
  /** Internal Risk Rating */
  internal_risk_rating?: string[] | null;
}

/** CIScorecard */
export interface CIScorecard {
  /**
   * Last Updated Date
   * @format date-time
   */
  last_updated_date: string;
  /** Forecast Years */
  forecast_years: number[];
  scenario: ClimateScenario;
  /** Aggregation Level */
  aggregation_level: number;
  /** Items */
  items: CIScorecardListItem[];
}

/** CIScorecardDrilldown */
export interface CIScorecardDrilldown {
  /**
   * Last Updated Date
   * @format date-time
   */
  last_updated_date: string;
  /** Forecast Years */
  forecast_years: number[];
  scenario: ClimateScenario;
  /** Aggregation Level */
  aggregation_level: number;
  /** Items */
  items: CIScorecardListItem[];
  /** Naics */
  naics: string;
  /** Code */
  code: string;
  /** Drilldown Level */
  drilldown_level: number;
  /** Drivers */
  drivers: string | null;
  /** Drivers Locked */
  drivers_locked: boolean;
}

/** CIScorecardListItem */
export interface CIScorecardListItem {
  /** Naics */
  naics: string;
  /** Code */
  code: string;
  /** Scores */
  scores: (ClimateScore | null)[];
}

/** CREAlertRuleInput */
export interface CREAlertRuleInput {
  /** Name */
  name: string;
  /**
   * Scenario Id
   * @format uuid
   */
  scenario_id: string;
  /** Conditions */
  conditions: Record<string, any>[];
  /** Additional Metrics */
  additional_metrics: string[];
  /** Loanbook Type */
  loanbook_type: "CRE";
  entity_type: EntityType;
  filters: CREEntityFilters;
}

/** CREBorrower */
export interface CREBorrower {
  /**
   * Borrower Id
   * @format uuid
   */
  borrower_id: string;
  /** External Id */
  external_id: string;
  /** Name */
  name: string;
  /** Classification Code */
  classification_code: string;
  /** Country */
  country: string;
  /** State */
  state: string | null;
  /** City */
  city: string | null;
  /** Address First Line */
  address_first_line: string | null;
  /** Number Of Loans */
  number_of_loans: number;
  /** High Risk Loans */
  high_risk_loans: number;
  total_exposure: MonetaryAmount | null;
  high_risk_exposure: MonetaryAmount | null;
  amount_drawn: MonetaryAmount | null;
  risk_score: RiskScore;
  /** Relationship Manager */
  relationship_manager: string;
  /** Business Unit */
  business_unit: string | null;
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
}

/** CREBorrowerLoanCompositionResponse */
export interface CREBorrowerLoanCompositionResponse {
  investment_loans_summary: LoanCompositionSummary;
  construction_loans_summary: LoanCompositionSummary;
  total_loans_summary: LoanCompositionSummary;
}

/** CREBorrowerLoansMetricsNTMResponse */
export interface CREBorrowerLoansMetricsNTMResponse {
  /** Metrics Ntm */
  metrics_ntm: EntityMetricNTM[];
}

/** CREBorrowerLoansResponse */
export interface CREBorrowerLoansResponse {
  /**
   * Borrower Id
   * @format uuid
   */
  borrower_id: string;
  /** Loans */
  loans: CRELoan[];
  page_info: PaginationInfo;
}

/** CREBorrowerLocationConcentration */
export interface CREBorrowerLocationConcentration {
  /** Borrower Exposure Percent */
  borrower_exposure_percent: number;
  total_valuation: MonetaryAmount;
  total_exposure: MonetaryAmount;
  ntm_risk_score: RiskScore | null;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[] | null;
  /** Country */
  country: string;
  /** State */
  state: string | null;
}

/** CREBorrowerPropertyConcentrationsResponse */
export interface CREBorrowerPropertyConcentrationsResponse {
  /** Ltm Period Start */
  ltm_period_start: string | null;
  /** Ltm Period End */
  ltm_period_end: string | null;
  /** Property Type Concentrations */
  property_type_concentrations: CREBorrowerPropertyTypeConcentration[];
  property_type_page_info: PaginationInfo;
  /** Property Location Concentrations */
  property_location_concentrations: CREBorrowerLocationConcentration[];
  property_location_page_info: PaginationInfo;
  all_concentration: CREConcentrationInfo;
}

/** CREBorrowerPropertyTypeConcentration */
export interface CREBorrowerPropertyTypeConcentration {
  /** Borrower Exposure Percent */
  borrower_exposure_percent: number;
  total_valuation: MonetaryAmount;
  total_exposure: MonetaryAmount;
  ntm_risk_score: RiskScore | null;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[] | null;
  property_type: PropertyType;
}

/** CREConcentrationInfo */
export interface CREConcentrationInfo {
  /** Borrower Exposure Percent */
  borrower_exposure_percent: number;
  total_valuation: MonetaryAmount;
  total_exposure: MonetaryAmount;
  ntm_risk_score: RiskScore | null;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[] | null;
}

/** CREEntityFilters */
export interface CREEntityFilters {
  exposure?: RangeFilter | null;
}

/** CRELoan */
export interface CRELoan {
  /**
   * Loan Id
   * @format uuid
   */
  loan_id: string;
  /** External Id */
  external_id: string;
  /** Number Of Assets */
  number_of_assets: number;
  total_exposure: MonetaryAmount;
  amount_drawn: MonetaryAmount;
  /** Relationship Manager */
  relationship_manager: string;
  ltm_risk_score: RiskScore;
  ntm_risk_score: RiskScore;
  borrower: CREBorrower;
  /** Start Date */
  start_date: string | null;
  /** Maturity Date */
  maturity_date: string | null;
  /** Remaining Tenure */
  remaining_tenure: number | null;
  /** Ltv */
  ltv: number | null;
  /** Interest Rate */
  interest_rate: number | null;
  /** Amortization Rate */
  amortization_rate: number | null;
  /** Last Updated Date */
  last_updated_date: string | null;
  loan_type: CRELoanType;
  /** Property Types */
  property_types: PropertyType[];
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
}

/** CREPortfolioAggregation */
export interface CREPortfolioAggregation {
  /** Total Borrowers */
  total_borrowers: number;
  /** Total Loans */
  total_loans: number;
  total_exposure: MonetaryAmount;
  /** Percent Exposure */
  percent_exposure: number;
  /** Ntm High Risk Loans */
  ntm_high_risk_loans: number;
  ntm_high_risk_exposure: MonetaryAmount;
  upcoming_maturities: MonetaryAmount;
  /** Wt Avg Interest Rate */
  wt_avg_interest_rate: number;
  /** Wt Avg Loan Tenure */
  wt_avg_loan_tenure: number;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[];
}

/** CREPortfolioBorrowerListItem */
export interface CREPortfolioBorrowerListItem {
  /**
   * Borrower Id
   * @format uuid
   */
  borrower_id: string;
  /** External Id */
  external_id: string;
  /** Name */
  name: string;
  /** Classification Code */
  classification_code: string;
  /** Country */
  country: string;
  /** State */
  state: string | null;
  /** City */
  city: string | null;
  /** Address First Line */
  address_first_line: string | null;
  /** Number Of Loans */
  number_of_loans: number;
  /** High Risk Loans */
  high_risk_loans: number;
  total_exposure: MonetaryAmount | null;
  high_risk_exposure: MonetaryAmount | null;
  amount_drawn: MonetaryAmount | null;
  risk_score: RiskScore;
  /** Relationship Manager */
  relationship_manager: string;
  /** Business Unit */
  business_unit: string | null;
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
  ntm_risk_score: RiskScore;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[];
}

/** CREPortfolioBorrowersResponse */
export interface CREPortfolioBorrowersResponse {
  /** Borrowers */
  borrowers: CREPortfolioBorrowerListItem[];
  page_info: PaginationInfo;
}

/** CREPortfolioForecastMetricsForPeriod */
export interface CREPortfolioForecastMetricsForPeriod {
  /**
   * Period Start
   * @format date
   */
  period_start: string;
  /**
   * Period End
   * @format date
   */
  period_end: string;
  scenario: ONCIScenario;
  /** Metrics */
  metrics: EntityMetricForecastResponseForPeriod[];
}

/** CREPortfolioLocationConcentration */
export interface CREPortfolioLocationConcentration {
  /** Borrower Exposure Percent */
  borrower_exposure_percent: number;
  total_valuation: MonetaryAmount;
  total_exposure: MonetaryAmount;
  ntm_risk_score: RiskScore | null;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[] | null;
  /** Country */
  country: string;
  /** State */
  state: string | null;
}

/** CREPortfolioPropertyConcentrationsResponse */
export interface CREPortfolioPropertyConcentrationsResponse {
  /** Property Type Concentrations */
  property_type_concentrations: CREPortfolioPropertyTypeConcentration[];
  property_type_page_info: PaginationInfo;
  /** Property Location Concentrations */
  property_location_concentrations: CREPortfolioLocationConcentration[];
  property_location_page_info: PaginationInfo;
  all_concentration: CREConcentrationInfo;
}

/** CREPortfolioPropertyTypeConcentration */
export interface CREPortfolioPropertyTypeConcentration {
  /** Borrower Exposure Percent */
  borrower_exposure_percent: number;
  total_valuation: MonetaryAmount;
  total_exposure: MonetaryAmount;
  ntm_risk_score: RiskScore | null;
  /** Risk Score Breakdown */
  risk_score_breakdown: RiskScoreComponent[] | null;
  property_type: PropertyType;
}

/** CREScorecard */
export interface CREScorecard {
  property_type: CREPropertyType;
  /** Forecast Years */
  forecast_years: number[];
  /** Scores */
  scores: CREScorecardStateScores[];
  /**
   * Last Updated Date
   * @format date-time
   */
  last_updated_date: string;
}

/** CREScorecardSectorDrilldown */
export interface CREScorecardSectorDrilldown {
  property_type: CREPropertyType;
  /** State */
  state: string;
  /** Drivers */
  drivers: string | null;
  /** Drivers Locked */
  drivers_locked: boolean;
  /** Scores */
  scores: (ClimateScore | null)[];
  /** Forecast Years */
  forecast_years: number[];
  /**
   * Last Updated Date
   * @format date-time
   */
  last_updated_date: string;
}

/** CREScorecardStateScores */
export interface CREScorecardStateScores {
  /** State */
  state: string;
  /** Scores */
  scores: (ClimateScore | null)[];
}

/** CalculatedValue */
export interface CalculatedValue {
  x: ScenarioMetricValue;
  y: ScenarioMetricValue;
  operation: Operation;
  /** Type */
  type: "CALCULATED_VALUE";
}

/** CheckoutRequest */
export interface CheckoutRequest {
  tier: SubscriptionTier;
}

/** ClientReferenceDateResponse */
export interface ClientReferenceDateResponse {
  /** Reference Date */
  reference_date: string | null;
}

/** ClimateScorecardUser */
export interface ClimateScorecardUser {
  /** Subscription Id */
  subscription_id: string | null;
  /** User Id */
  user_id: string;
  scorecard_tier: ScorecardTier;
}

/** ConfigurationOptions */
export interface ConfigurationOptions {
  /** Scenarios */
  scenarios: ClimateScenario[];
  /** Naics Levels */
  naics_levels: number[];
  /** Property Types */
  property_types: CREPropertyType[];
}

/** CreateTrialRequest */
export interface CreateTrialRequest {
  /** Trial Code */
  trial_code: string;
}

/** Document */
export interface Document {
  /** Id */
  id: number;
  /** Downloadurl */
  downloadUrl: string;
  /** Filename */
  fileName: string;
  /** Uploadedat */
  uploadedAt: string;
  /** Creditmemoid */
  creditMemoId?: number | null;
  /** Creditmemoname */
  creditMemoName?: string | null;
  /** Borrowers */
  borrowers?: LegalEntity[] | null;
  fileType?: FileType | null;
  uploadedBy?: User | null;
}

/** DocumentDownloadUrl */
export interface DocumentDownloadUrl {
  /** Id */
  id: number;
  /** Url */
  url: string;
}

/** DocumentListingResponse */
export interface DocumentListingResponse {
  /** Totaldocumentcount */
  totalDocumentCount: number;
  /** Documents */
  documents: Document[];
}

/**
 * DocumentUploadUrl
 * Wraps a presigned S3 URL to upload a file to
 */
export interface DocumentUploadUrl {
  /** Url */
  url: string;
  /** Filekey */
  fileKey: string;
  /** Formfields */
  formFields: Record<string, string>;
}

/** DocumentUploadUrlList */
export interface DocumentUploadUrlList {
  /** Entries */
  entries: DocumentUploadUrl[];
}

/** DocumentUploadV2 */
export interface DocumentUploadV2 {
  /** Filename */
  fileName: string;
  /** Filekey */
  fileKey: string;
}

/** DocumentUploadV2List */
export interface DocumentUploadV2List {
  /** Entries */
  entries: DocumentUploadV2[];
}

/** EntityMetricForecastResponse */
export interface EntityMetricForecastResponse {
  metric: Metric;
  scenario: ONCIScenario;
  /** Forecasted Period Ends */
  forecasted_period_ends: string[];
  /** Forecasted Values */
  forecasted_values: (number | null)[];
}

/** EntityMetricForecastResponseForPeriod */
export interface EntityMetricForecastResponseForPeriod {
  metric: Metric;
  /** Ltm Value */
  ltm_value: number | null;
  /** Forecasted Value */
  forecasted_value: number | null;
}

/** EntityMetricNTM */
export interface EntityMetricNTM {
  metric: Metric;
  scenario: ONCIScenario;
  /** Ltm Period Start */
  ltm_period_start: string | null;
  /** Ltm Period End */
  ltm_period_end: string | null;
  /** Ltm Value */
  ltm_value: number | RiskScore | null;
  /** Ntm Period Start */
  ntm_period_start: string | null;
  /** Ntm Period End */
  ntm_period_end: string | null;
  /** Ntm Value */
  ntm_value: number | RiskScore | null;
}

/** EntityMetricValuesV2 */
export interface EntityMetricValuesV2 {
  metric: Metric;
  /** Metric Values */
  metric_values: (number | RiskScore | null)[];
  /** Ltm Metric Value */
  ltm_metric_value: number | RiskScore | null;
  /** Ntm Metric Value */
  ntm_metric_value: number | RiskScore | null;
  /** Position */
  position: number;
  significance: EntityMetricSignificance;
  /** Parent */
  parent: string | null;
  /** Blank Space Before */
  blank_space_before: boolean;
}

/** EntityMetricsResponseV2 */
export interface EntityMetricsResponseV2 {
  /** Period Ends */
  period_ends: FinancialPeriod[];
  /**
   * Ltm Period Start
   * @format date
   */
  ltm_period_start: string;
  /**
   * Ltm Period End
   * @format date
   */
  ltm_period_end: string;
  /**
   * Ntm Period Start
   * @format date
   */
  ntm_period_start: string;
  /**
   * Ntm Period End
   * @format date
   */
  ntm_period_end: string;
  /** Metrics */
  metrics: EntityMetricValuesV2[];
}

/** EntityNote */
export interface EntityNote {
  /** Content */
  content: string;
  /** Author */
  author: string;
  /**
   * Last Modified
   * @format date-time
   */
  last_modified: string;
}

/** EntityNoteInput */
export interface EntityNoteInput {
  /** Content */
  content: string;
}

/** EntityOverviewMetricValue */
export interface EntityOverviewMetricValue {
  metric: Metric;
  /** Value */
  value: number | null;
  /** Market Value */
  market_value: number | null;
  /** Market Metric Name */
  market_metric_name: string | null;
  /**
   * Value Reported Date
   * @format date
   */
  value_reported_date: string;
}

/** EntityOverviewMetricsResponse */
export interface EntityOverviewMetricsResponse {
  /**
   * Entity Id
   * @format uuid
   */
  entity_id: string;
  /** Metrics */
  metrics: EntityOverviewMetricValue[];
}

/** EntityRiskScoreResponse */
export interface EntityRiskScoreResponse {
  /**
   * Entity Id
   * @format uuid
   */
  entity_id: string;
  /** Riskscoreinsights */
  riskScoreInsights: string;
  scenario: ONCIScenario;
  /** Ltm Period Start */
  ltm_period_start: string | null;
  /** Ltm Period End */
  ltm_period_end: string | null;
  /** Ntm Period Start */
  ntm_period_start: string | null;
  /** Ntm Period End */
  ntm_period_end: string | null;
  ltm_score: RiskScore;
  ntm_score: RiskScore;
  /** Risk Score Components Data */
  risk_score_components_data: RiskScoreComponent[];
}

/** ExcludedBorrower */
export interface ExcludedBorrower {
  /**
   * Legal Entity Id
   * @format uuid
   */
  legal_entity_id: string;
  /** Exposure */
  exposure: number;
  /** Name */
  name: string;
  naics_info: NaicsInfo;
  /** Internal Risk Rating */
  internal_risk_rating: string | null;
}

/** ExcludedBorrowerOverview */
export interface ExcludedBorrowerOverview {
  /**
   * Legal Entity Id
   * @format uuid
   */
  legal_entity_id: string;
  /** Exposure */
  exposure: number;
  /** Name */
  name: string;
  naics_info: NaicsInfo;
  /** Internal Risk Rating */
  internal_risk_rating: string | null;
  /** Relationship Manager */
  relationship_manager: string | null;
}

/** ExcludedBorrowerReasonsResponse */
export interface ExcludedBorrowerReasonsResponse {
  borrower_overview: ExcludedBorrowerOverview;
  /** Exclusion Reasons */
  exclusion_reasons: ExclusionReason[];
}

/** ExcludedBorrowersResponse */
export interface ExcludedBorrowersResponse {
  page_info: PaginationInfo;
  /** Excluded Borrowers */
  excluded_borrowers: ExcludedBorrower[];
}

/** ExclusionReason */
export interface ExclusionReason {
  /** Reason */
  reason: string;
  /** Files */
  files: BorrowerSpreadFile[];
}

/** FinancialPeriod */
export interface FinancialPeriod {
  period_type: PeriodType;
  /**
   * Period Start
   * @format date
   */
  period_start: string;
  /**
   * Period End
   * @format date
   */
  period_end: string;
  financials_type: FinancialsType;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** KPIComparisonMetric */
export interface KPIComparisonMetric {
  /** Actual Values */
  actual_values: (number | null)[];
  /** Nowcasted Values */
  nowcasted_values: (number | null)[];
  /** Forecasted Values */
  forecasted_values: (number | null)[];
}

/** KPIComparisonResponse */
export interface KPIComparisonResponse {
  metric: Metric;
  /** Market Metric Name */
  market_metric_name: string;
  /** Actual Period Starts */
  actual_period_starts: string[];
  /** Actual Period Ends */
  actual_period_ends: string[];
  /** Nowcasted Period Starts */
  nowcasted_period_starts: string[];
  /** Nowcasted Period Ends */
  nowcasted_period_ends: string[];
  /** Forecasted Period Starts */
  forecasted_period_starts: string[];
  /** Forecasted Period Ends */
  forecasted_period_ends: string[];
  metric_values: KPIComparisonMetric;
  market_values: KPIComparisonMetric;
}

/** LegalEntity */
export interface LegalEntity {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Country */
  country: string;
  /** Description */
  description?: string | null;
}

/** LiteralValue */
export interface LiteralValue {
  /** Value */
  value: number | VRScore;
  /** Type */
  type: "LITERAL";
}

/** LoanAssetResponse */
export interface LoanAssetResponse {
  /**
   * Loan Id
   * @format uuid
   */
  loan_id: string;
  /** Loan Asset */
  loan_asset:
    | ({
        asset_type: "PROPERTY";
      } & Property)
    | ({
        asset_type: "VESSEL";
      } & Vessel);
}

/** LoanAssetsResponse */
export interface LoanAssetsResponse {
  /** Loan Assets */
  loan_assets: (
    | ({
        asset_type: "PROPERTY";
      } & Property)
    | ({
        asset_type: "VESSEL";
      } & Vessel)
  )[];
}

/** LoanCompositionSummary */
export interface LoanCompositionSummary {
  /** Total Loans Count */
  total_loans_count: number;
  total_exposure: MonetaryAmount;
  total_amount_drawn: MonetaryAmount;
  /** Wt Avg Interest Rate */
  wt_avg_interest_rate: number;
  exposure_maturing_six_mo: MonetaryAmount;
  exposure_maturing_twelve_mo: MonetaryAmount;
  /** High Risk Loans */
  high_risk_loans: number;
  high_risk_exposure: MonetaryAmount;
  /** High Risk Percent */
  high_risk_percent: number;
  /** Alerting Loans Count */
  alerting_loans_count: number;
}

/** LoanResponse */
export interface LoanResponse {
  loan: CRELoan;
}

/** Metric */
export interface Metric {
  /** Mnemonic */
  mnemonic: string;
  /** Name */
  name: string;
  data_type: MetricDataType;
}

/** MetricExplainabilityFile */
export interface MetricExplainabilityFile {
  /** File Id */
  file_id: number;
  /**
   * Entity Id
   * @format uuid
   */
  entity_id: string;
  /** Scenario Id */
  scenario_id: string;
  /** Mnemonic */
  mnemonic: string;
  /** Period Start */
  period_start: string;
  /** Period End */
  period_end: string;
  status: ExplainabilityStatus;
  /**
   * Requested At
   * @format date-time
   */
  requested_at: string;
  /** Generated At */
  generated_at?: string | null;
  /** S3 Path */
  s3_path?: string | null;
  /** Entity Name */
  entity_name?: string | null;
}

/** MetricExplainabilityFileDownloadUrl */
export interface MetricExplainabilityFileDownloadUrl {
  /** File Id */
  file_id: number;
  /** Url */
  url: string;
  /** Filename */
  filename: string;
}

/** MetricExplainabilityFileRequest */
export interface MetricExplainabilityFileRequest {
  /**
   * Entity Id
   * @format uuid
   */
  entity_id: string;
  /** Scenario Id */
  scenario_id: string;
  /** Mnemonic */
  mnemonic: string;
  /** Period Start */
  period_start: string;
  /** Period End */
  period_end: string;
  /** Entity Name */
  entity_name?: string | null;
}

/** MetricExplainabilityFileResponse */
export interface MetricExplainabilityFileResponse {
  page_info: PaginationInfo;
  /** Files */
  files: MetricExplainabilityFile[];
}

/** MonetaryAmount */
export interface MonetaryAmount {
  /** Value */
  value: number;
  /** Currency */
  currency: string;
}

/** NaicsInfo */
export interface NaicsInfo {
  /** Name */
  name: string | null;
  /** Code */
  code: string | null;
}

/** PaginationInfo */
export interface PaginationInfo {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Total Count */
  total_count: number;
}

/** PeriodEndResponse */
export interface PeriodEndResponse {
  /**
   * Reference Date
   * @format date
   */
  reference_date: string;
  /**
   * Ltm Period Start
   * @format date
   */
  ltm_period_start: string;
  /**
   * Ltm Period End
   * @format date
   */
  ltm_period_end: string;
  /**
   * Ntm Period Start
   * @format date
   */
  ntm_period_start: string;
  /**
   * Ntm Period End
   * @format date
   */
  ntm_period_end: string;
  /** Actual Period Start Dates */
  actual_period_start_dates: string[];
  /** Actual Period End Dates */
  actual_period_end_dates: string[];
  /** Nowcasted Period Start Dates */
  nowcasted_period_start_dates: string[];
  /** Nowcasted Period End Dates */
  nowcasted_period_end_dates: string[];
  /** Forecast Period Start Dates */
  forecast_period_start_dates: string[];
  /** Forecast Period End Dates */
  forecast_period_end_dates: string[];
}

/** Property */
export interface Property {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** External Id */
  external_id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Number Of Units */
  number_of_units: number;
  total_exposure: MonetaryAmount;
  amount_drawn: MonetaryAmount;
  amount_undrawn: MonetaryAmount;
  /** Preview Url */
  preview_url: string[];
  valuation: MonetaryAmount | null;
  /** Valuation Date */
  valuation_date: string | null;
  loan: CRELoan;
  loan_type: CRELoanType;
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
  /** Asset Type */
  asset_type: "PROPERTY";
  property_type: PropertyType;
  /** Country */
  country: string;
  /** State */
  state: string | null;
  /** City */
  city: string | null;
  /** Latitude */
  latitude: number | null;
  /** Longitude */
  longitude: number | null;
  /** Elevation */
  elevation: number | null;
  /** Address First Line */
  address_first_line: string | null;
  /** Year Of Construction */
  year_of_construction: string | null;
  /** Number Of Floors */
  number_of_floors: number | null;
  /** Gross Area */
  gross_area: number | null;
  /** Net Leasable Area */
  net_leasable_area: number | null;
  /** Pct Leased */
  pct_leased: number | null;
  annual_rent: MonetaryAmount | null;
  /** Wt Avg Lease Tenure */
  wt_avg_lease_tenure: number | null;
  /** Ltm Implied Cap Rate */
  ltm_implied_cap_rate: number | null;
  /** Ltm Net Operating Income */
  ltm_net_operating_income: number | null;
}

/** PropertyTypesResponse */
export interface PropertyTypesResponse {
  /** Property Types */
  property_types: PropertyType[];
}

/** RangeFilter */
export interface RangeFilter {
  /** Min */
  min?: number | null;
  /** Max */
  max?: number | null;
}

/** RedirectResponse */
export interface RedirectResponse {
  /**
   * Url
   * @deprecated
   */
  url: string;
  /** Redirect Url */
  redirect_url: string;
}

/** RelationshipManagersResponse */
export interface RelationshipManagersResponse {
  /** Relationship Managers */
  relationship_managers: string[];
}

/** RiskScoreComponent */
export interface RiskScoreComponent {
  metric: Metric;
  /** Weighting */
  weighting: number;
  /** Ltm Value */
  ltm_value: number | null;
  ltm_score: RiskScore;
  /** Ntm Value */
  ntm_value: number | null;
  ntm_score: RiskScore | null;
}

/** Scenario */
export interface Scenario {
  /**
   * Scenario Id
   * @format uuid
   */
  scenario_id: string;
  /** Name */
  name: string;
  status: CalculationStatus;
  /** Is Base Scenario */
  is_base_scenario: boolean;
}

/** ScenarioMetricValue */
export interface ScenarioMetricValue {
  metric: Metric;
  range_type: RangeType;
  /**
   * Date Offset
   * ISO 8601 duration string, https://docs.digi.com/resources/documentation/digidocs/90001488-13/reference/r_iso_8601_duration_format.htm
   */
  date_offset?: string | null;
  /**
   * History Offset
   * ISO 8601 duration string, https://docs.digi.com/resources/documentation/digidocs/90001488-13/reference/r_iso_8601_duration_format.htm
   */
  history_offset?: string | null;
  /** Type */
  type: "METRIC_VALUE";
}

/** StatesResponse */
export interface StatesResponse {
  /** States */
  states: string[];
}

/** Tenant */
export interface Tenant {
  /**
   * Tenant Id
   * @format uuid
   */
  tenant_id: string;
  /** Name */
  name: string;
  /** Net Leasable Area */
  net_leasable_area: number | null;
  /** Pct Leased */
  pct_leased: number | null;
  annual_rent: MonetaryAmount | null;
  /** Pct Total Rent */
  pct_total_rent: number | null;
  /** Lease End Date */
  lease_end_date: string | null;
  property: Property;
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
}

/** TenantInformation */
export interface TenantInformation {
  /** Is Scorecard Tenant */
  is_scorecard_tenant: boolean;
}

/** User */
export interface User {
  /** Id */
  id: string;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** Vessel */
export interface Vessel {
  /**
   * Asset Id
   * @format uuid
   */
  asset_id: string;
  /** External Id */
  external_id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Number Of Units */
  number_of_units: number;
  total_exposure: MonetaryAmount;
  amount_drawn: MonetaryAmount;
  amount_undrawn: MonetaryAmount;
  /** Preview Url */
  preview_url: string[];
  valuation: MonetaryAmount | null;
  /** Valuation Date */
  valuation_date: string | null;
  loan: CRELoan;
  loan_type: CRELoanType;
  /**
   * Reported Date
   * @format date
   */
  reported_date: string;
  /** Asset Type */
  asset_type: "VESSEL";
}

/** Alert Rule Input */
export type CreateAlertRulePayload =
  | ({
      loanbook_type: "CI";
    } & CIAlertRuleInput)
  | ({
      loanbook_type: "CRE";
    } & CREAlertRuleInput);

/** Alert Rule Input */
export type UpdateAlertRulePayload =
  | ({
      loanbook_type: "CI";
    } & CIAlertRuleInput)
  | ({
      loanbook_type: "CRE";
    } & CREAlertRuleInput);
